// src/components/ManifestPage.jsx
import React from "react";
import manifest from "../data/manifest";
import ManifestItemCard from "../kits/ManifestKit/ManifesItemCard";

import KompassSchema from "./utils/KompassSchema";

const ManifestPage = () => {
  return (
    <>
    <KompassSchema />
   
      <section className="py-20 px-6 font-mono text-black">
        <div className="max-w-3xl mx-auto space-y-12">
    {/* Headline */}
          <div className="text-center" data-aos="fade-up" data-aos-delay="100">
            <div className="relative inline-block">
          
                <img
              src={`${process.env.PUBLIC_URL}/images/kompass1.svg`}
              alt="Kompass gezeichnet"
              className="w-full max-w-[160px] md:max-w-[200px] lg:max-w-[200px] h-auto mx-auto  object-contain"
            />
       
            </div>
          </div>
    
       

      

          {/* Manifest Cards mit Staggered-Delay */}
          <div className="grid gap-6 grid-cols-1
          ">
            {manifest.map((item, index) => (
              <div
                key={item.id}
                data-aos="fade-up"
                data-aos-delay={index * 100} // z.B. 0, 100, 200...
              >
                <ManifestItemCard {...item} />
              </div>
            ))}
          </div>

        </div>
      </section>

    </>
  );
};

export default ManifestPage;
